import { render, staticRenderFns } from "./xuanzejiedanren.vue?vue&type=template&id=e8250c32&scoped=true&"
import script from "./xuanzejiedanren.vue?vue&type=script&lang=js&"
export * from "./xuanzejiedanren.vue?vue&type=script&lang=js&"
import style0 from "./xuanzejiedanren.vue?vue&type=style&index=0&id=e8250c32&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8250c32",
  null
  
)

export default component.exports